<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <div class="zj-plan-task-com-sett">
      <el-tabs class="setting-tabs no-active-bar" v-model="activeName">
        <el-tab-pane
          :key="item.name"
          v-for="item in EmergencyTaskSubType"
          :label="item.Description"
          :name="item.ItemKey"
        >
          <ComponentSMSDetail
            v-if="item.ItemKey == 'EmergencyTaskType.Communication.Sms'"
            :ref="item.ItemKey"
            :PlanTaskId="PlanTaskId"
            :TaskSubTypeId="item.ItemKey"
            @loading="showLoading"
            @loadingFinish="hideLoading"
          />
          <ComponentLEDDetail
            v-if="item.ItemKey == 'EmergencyTaskType.Communication.Led'"
            :ref="item.ItemKey"
            :PlanTaskId="PlanTaskId"
            :TaskSubTypeId="item.ItemKey"
            @loading="showLoading"
            @loadingFinish="hideLoading"
          />
          <ComponentradioDetail
            v-if="item.ItemKey == 'EmergencyTaskType.Communication.Broadcast'"
            :ref="item.ItemKey"
            :PlanTaskId="PlanTaskId"
            :TaskSubTypeId="item.ItemKey"
            @loading="showLoading"
            @loadingFinish="hideLoading"
          />
          <ComponentWeChatDetail
            v-if="item.ItemKey == 'EmergencyTaskType.Communication.WeChat'"
            :ref="item.ItemKey"
            :PlanTaskId="PlanTaskId"
            :TaskSubTypeId="item.ItemKey"
            @loading="showLoading"
            @loadingFinish="hideLoading"
          />
          <ComponentAPPDetail
            v-if="item.ItemKey == 'EmergencyTaskType.Communication.Keepwatch'"
            :ref="item.ItemKey"
            :PlanTaskId="PlanTaskId"
            :TaskSubTypeId="item.ItemKey"
            @loading="showLoading"
            @loadingFinish="hideLoading"
          />
          <ComponentAPPDetail
            v-if="item.ItemKey == 'EmergencyTaskType.Communication.ManageApp'"
            :ref="item.ItemKey"
            :PlanTaskId="PlanTaskId"
            :TaskSubTypeId="item.ItemKey"
            @loading="showLoading"
            @loadingFinish="hideLoading"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-form>
</template>
<script>
import ComponentSMSDetail from "./ComponentSMSDetail";
import ComponentLEDDetail from "./ComponentLEDDetail";
import ComponentradioDetail from "./ComponentradioDetail";
import ComponentAPPDetail from "./ComponentAPPDetail";
import ComponentWeChatDetail from "./ComponentWeChatDetail";

import MyApis from "../../../apis";

export default {
  name: "ZjCommunicationSettingInfo",
  controller: "UI",
  action: "CommunicationSettingInfo",
  components: {
    ComponentSMSDetail,
    ComponentLEDDetail,
    ComponentradioDetail,
    ComponentAPPDetail,
    ComponentWeChatDetail,
  },
  props: {
    PlanTaskId: { type: String },
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      activeName: "",
      EmergencyTaskSubType: [],
      ruleForm: {
        PlanTaskId: this.$props.PlanTaskId,
      },
    };
  },
  created: function () {
    this.loadingRef = 0;
    this.showLoading("加载中...");
    this.config
      .getUValue("EmergencyService:EmergencyTaskType-Communication", "")
      .then((d) => {
        var data = d.JValue;
        if (data) {
          this.activeName = data[0].ItemKey;
          this.EmergencyTaskSubType = data;
          this.hideLoading();
          this.search();
        }
      })
      .catch((e) => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.hideLoading();
      });
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    showLoading(text) {
      this.loadingRef++;
      this.loading = true;
      this.loadingText =
        typeof text !== "undefined" && text !== null ? text : "加载中...";
    },
    hideLoading() {
      this.loadingRef--;
      if (this.loadingRef == 0) {
        this.loading = false;
      }
    },
    search() {
      let PlanTaskId = this.$props.PlanTaskId;
      if (PlanTaskId != null && PlanTaskId != "") {
        let searchInfo = {
          PlanTaskId: PlanTaskId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
        this.showLoading("加载中...");
        new MyApis.PlantasksettingApi()
          .FindByConditions(searchInfo)
          .then((r) => {
            var data = r.data.Data;
            if (data.length > 0) {
              this.ruleForm = data[0];
              this.setActiveName(this.ruleForm.TaskSubTypeId);
            }
            this.hideLoading();
          })
          .catch((e) => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
          });
      }
    },
    setActiveName(taskSubTypeId) {
      if (this.EmergencyTaskSubType && this.EmergencyTaskSubType.length > 0) {
        var item = this.EmergencyTaskSubType.find((a) => {
          return a.ItemKey == taskSubTypeId;
        });

        if (item) {
          this.activeName = item.ItemKey;
        }
      }
    },
  },
};
</script>
<style>
.zj-plan-task-com-sett
  > .setting-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .is-active {
  background: url(/img/tabselected.png) no-repeat !important;
  background-size: 100% 100% !important;
  background-position: center !important;
}
.zj-plan-task-com-sett
  > .setting-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__active-bar {
  display: none;
}
.zj-plan-task-com-sett .el-tabs__item {
  width: 16rem;
  text-align: -webkit-center;
}
.zj-plan-task-com-sett
  > .setting-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__item {
  background: url(/img/tab.png) no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
</style>>
